import type { Chapter } from "../types/common";

// 117901：從前台選題清單隱藏的章節(純前端過濾，不動後端資料，清空此清單即還原）
export const HIDDEN_CHAPTER_NAMES: readonly string[] = [
  "114學測模擬試題-國寫(第1次)-知性",
  "114學測模擬試題-國寫(第1次)-情意",
  "114學測模擬試題-國寫(第3次)-知性",
  "114學測模擬試題-國寫(第3次)-情意",
];

export const filterHiddenChapters = (chapters: Chapter[]): Chapter[] => {
  const arr = Array.isArray(chapters) ? chapters : [];
  return arr.filter((ch) => !HIDDEN_CHAPTER_NAMES.includes(ch.chapter));
};
